Vendd.Scripts.load(function () {
    'use strict';
   
    (function() { // Init dataLayer 
        window.dataLayer = window.dataLayer || [];
        var dl = window.dataLayer;
        var originalPush = dl.push;
        dl.push = function (args) {
            // Prevent the push of vendd_consents_ready
            if (args.event && args.event == "vendd_consents_ready") return;

            originalPush.call(window.dataLayer, args);
            onDataLayerPush(args); // Hook to dataLayer.push method
        }
        function onDataLayerPush(args) {
            if (typeof args.event == "undefined") return;

            if (args.event === 'OneTrustLoaded') {
                if (args.OnetrustActiveGroups.indexOf('C0002') > -1) {
                    skodaVariables.consents.analytics = true;
                    initScripts('analytics');
                }
                if (args.OnetrustActiveGroups.indexOf('C0004') > -1) {
                    skodaVariables.consents.marketing = true;
                    initScripts('marketing');
                }
            }

            // Track events with gtag for Ukraine
            if (skodaVariables.countryCode === "ua" && typeof gtag === 'function' && args.event === "trackEvent") {
                gtagEventsUkr(args);                
            }
        }
        function gtagEventsUkr(args) {
            // Form submit
            if (args["appweb.Name"] === "form_submit" && args.eventAction === "dealers_test_drive") {
                gtag('event', 'form_submit_test_drive');
            }

            if (args["appweb.Name"] === "form_submit" && args.eventAction === "dealers_request_quote") {
                gtag('event', 'form_submit_price_request');
            }

            if (args["appweb.Name"] === "form_submit" && args.eventAction === "dealers_service") {
                gtag('event', 'form_submit_service');
            }

            if (args["appweb.Name"] === "form_submit" && args.eventAction === "stockcars_form") {
                gtag('event', 'form_submit_request');
            }

            // Download documents
            if (args.event_name === "download" && args.document_type === "Pricelist") {
                gtag('event', 'click_document_download_price_list');
            }

            if (args.event_name === "download" && args.document_type === "Brochure") {
                gtag('event', 'click_document_download_specifications');
            }

            // CTA clicks
            if (args.event_name === "cta_click" && args.cms_code === "view_full_specification") {
                gtag('event', 'click_full_specifications');
            }

            if (args.event_name === "cta_click" && args.cms_code === "car_configurator") {
                gtag('event', 'click_configurator');
            }

            if (args.event_name === "cta_click"
                && (args.cms_code === "partners_phone" || args.cms_code === "ItemAttributes_MainPhone")
                && args.hit_click_url
            ) {
                gtag('event', 'click_phone', {
                    'phone_number': args.hit_click_url.replace('tel:', '')
                });
            }

            //Button click, based on labels: "Прайс-лист" | "Каталог" | "Аксесуари" | "Комплектації" | "Конфігуратор"
            if (args.event_name === "button_click"
                && args.event_label && contains(args.event_label, "Прайс-лист")
            ) {
                gtag('event', 'click_document_download_price_list');
            }

            if (args.event_name === "button_click" && args.event_label === "Каталог") {
                gtag('event', 'click_document_download_catalog');
            }

            if (args.event_name === "button_click" && args.event_label === "Аксесуари"
            ) {
                gtag('event', 'click_document_download_accessories');
            }

            if (args.event_name === "button_click"
                && args.event_label && contains(args.event_label, "Комплектації")
            ) {
                gtag('event', 'click_document_download_specifications');
            }

            if (args.event_name === "button_click"
                && args.event_label && contains(args.event_label, "Конфігуратор")
            ) {
                gtag('event', 'click_configurator');
            }
        }
    })();


    // Helper function to check if a string contains a substring, with support for older browsers
    function contains(str, search, position) {
        position = position || 0;

        if (String.prototype.includes) {
            return str.includes(search, position);
        }

        return str.indexOf(search, position) !== -1;
    }
});